module.exports = "<p>\n  app-user-detail works!\n</p>\n"